module.exports = __webpack_public_path__ + "static/leavesster-d658f2bab9f7433906c1391e4acc2683.png";